import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetTriggerOptionsResponseTO } from 'models/automation/Triggers';
import API from 'services/API';

export const TRIGGER_OPTIONS_BASE_QUERY_KEY = 'trigger-options';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetTriggerOptionsResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchTriggerOptionsArgs = ReactQueryOptions;

const useFetchTriggerOptions = ({
  enabled = true,
  ...options
}: UseFetchTriggerOptionsArgs = {}) => {
  return useAppQuery<GetTriggerOptionsResponseTO>({
    queryKey: [TRIGGER_OPTIONS_BASE_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await API.get<GetTriggerOptionsResponseTO>(
        '/api/internal/triggers/create/options',
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchTriggerOptions;
